import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgUnderBedStorage = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 22,
  height: 21,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 13a1 1 0 0 1 .993.883L18 14a1 1 0 0 1 .117 1.993L18 16v2a1 1 0 0 1 .117 1.993L18 20a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2H2.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H4a2 2 0 0 1 2-2h11Zm0 1H6a1 1 0 0 0-.993.883L5 15v4a1 1 0 0 0 .883.993L6 20h11v-6ZM4 16H3v2h1v-2Zm18-5v1H0v-1h22ZM11.5 0v7.126l3.146-3.146.708.707L11 9.04 6.646 4.687l.708-.707L10.5 7.126 10.5 0h1Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgUnderBedStorage;